import { Pipe, PipeTransform } from '@angular/core';
/**
 * Returns negative number in ()
 */
@Pipe({ name: 'rdFormatNegativeNumbers' })
export class RdFormatNegativeNumbersPipe implements PipeTransform {

  /**
   * Returns negative number in ()
   * @param input Numeric input
   */
  transform(input: any): string {
    let formattedValue = input;
    if (+(input.replaceAll(',', '')) < 0) {
      formattedValue = `(${input.replace('-', '')})`;
    }

    return formattedValue;
  }
}
